import { useEffect } from 'react';
import { RgbColor, rgbToHex } from '~/shared';
import { TextLabelStrokeRoboto } from '../TextLabelStroke';

interface IServerMessageProps {
	text: string;
	color: RgbColor;
	onRender?: () => void;
}

const ServerMessage: React.FC<IServerMessageProps> = ({
	text,
	color,
	onRender,
}: IServerMessageProps) => {
	useEffect(() => {
		onRender?.();
	}, []);

	return (
		<TextLabelStrokeRoboto style={{ fontSize: 14, justifyContent: 'start' }}>
			<span style={{ fontWeight: 600, color: `#${rgbToHex(color)}` }}>
				{text}
			</span>
		</TextLabelStrokeRoboto>
	);
};

export { ServerMessage };
